import { FaBriefcase, FaRegClock, FaLink, FaCalendarAlt, FaUser, 
        FaEnvelope, FaGoogle, FaPhoneAlt, FaDollarSign, FaBrain} from "react-icons/fa";

import {GiBrain} from "react-icons/gi"; 
import './AppointmentPage.css';


const AppointmentSummary = ({
  selectedService,
  serviceCost,
  selectedDoctor,
  drawnDoctor,
  selectedDate,
  selectedTime,
  selectValue,
  isCheck,
  setIsChecked,
}) => {


  const { firstName, lastName, email, phoneNumber, 
    city, zipCode, street, addressNo, state, country,
    additionalInfo } = selectValue;


  function formatAddress(city, zipCode, street, addressNo, state, country) {
    if (!city) return "BRAK PODANEGO ADRESU!";

    // Build an array dynamically, filtering out empty values
    const addressParts = [
        `ul. ${street || ""} ${addressNo || ""}`.trim(),
        zipCode ? `${zipCode} ${city ? `${city}` : ""},` : "",
        state ? `${state}, ${country}` : "",
    ];

    // Filter out empty values and join with a newline
    return addressParts.filter(part => part);
  }

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
    const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits
    const weekday = date.toLocaleDateString("pl-PL", { weekday: "long" });
    return `${weekday.charAt(0).toUpperCase() + weekday.slice(1)}, ${year}-${month}-${day}`; // Return the formatted date
  };

  const handleCheck = () => {
    setIsChecked(!isCheck);
  };


  return (
    <div style={{ marginTop: "2rem" }}>
      <dir className="p-3" style={{ background: "#f8f9fa" }}>
        <div className="row">
          <div className="col-md-6 col-sm-12 mt-3 info-part border-end">
            <p className="py-2 border-bottom info-head-date">
              Informacje o wizycie
            </p>
            <div className="icon-box">
              <div className="d-flex gap-3">
                <GiBrain className="icon" />
                <p style={{ fontWeight: "500" }}>
                  Usługa:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {selectedService.label === 'Konsultacje psychologiczne' ? selectedService.label : 
                      `diagnoza ${selectedService.label}`}
                  </span>
                </p>
              </div>
              <div className="d-flex gap-3">
                <FaBriefcase className="icon" />
                <p style={{ fontWeight: "500" }}>
                  Diagnosta:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {selectedDoctor.value !== 'all' ? selectedDoctor.label : drawnDoctor.label}
                  </span>
                </p>
              </div>
              <div className="d-flex gap-3">
                <FaCalendarAlt className="icon" />
                <p style={{ fontWeight: "500" }}>
                  Data:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {selectedDate && selectedTime && formatDate(selectedDate)}
                  </span>
                </p>
              </div>
              <div className="d-flex gap-3">
                <FaRegClock className="icon" />
                <p style={{ fontWeight: "500" }}>
                  Godzina:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {selectedDate && selectedTime && selectedTime}
                  </span>
                </p>
              </div>
              <div className="d-flex gap-3">
                <FaDollarSign className="icon" />
                <p style={{ fontWeight: "500" }}>
                  Koszt:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {selectedDate && selectedTime && 
                    `${serviceCost.find(entry => entry.value=selectedService.value).label} zł`}
                  </span>
                </p>
              </div>
              <div className="d-flex gap-3">
                <FaGoogle className="icon" />
                <p style={{ fontWeight: "500" }}>
                  Miejsce:{" "}
                  <span style={{ fontWeight: "bold" }}>Google Meet</span>
                </p>
              </div>
              <div className="d-flex gap-3">
                <FaLink className="icon" />
                <p style={{ fontWeight: "500" }}>
                  Link do spotkania zostanie wysłany na wskazany adres email.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-sm-12 mt-3 info-part">
            <p className="py-2 border-bottom info-head-date">
              Dane Osobowe Pacjenta
            </p>
            <div className="icon-box">
              <div className="d-flex gap-3">
                <FaUser className="icon" />
                <p style={{ fontWeight: "500" }}>
                  Imię: <span style={{ fontWeight: "bold", marginLeft: "10px" }}>{firstName}</span>
                </p>
              </div>
              <div className="d-flex gap-3">
                <FaUser className="icon" />
                <p style={{ fontWeight: "500" }}>
                  Nazwisko:{" "}
                  <span style={{ fontWeight: "bold", marginLeft: "10px" }}>{lastName}</span>
                </p>
              </div>
              <div className="d-flex gap-3">
                <FaEnvelope className="icon" />
                <p style={{ fontWeight: "500" }}>
                  Email: <span style={{ fontWeight: "bold", marginLeft: "10px" }}>{email}</span>
                </p>
              </div>
              <div className="d-flex gap-3">
                <FaPhoneAlt className="icon" />
                <p style={{ fontWeight: "500" }}>
                  Telefon:{" "}
                  <span style={{ fontWeight: "bold", marginLeft: "10px" }}>(+48) {phoneNumber}</span>
                </p>
              </div>
              <div className="d-flex gap-3">
                <FaUser className="icon" />
                <p style={{ fontWeight: "500" }}>
                  Adres: 
                  <span style={{ fontWeight: "bold", marginLeft: "20px", whiteSpace: "pre-line" }}>
                    {formatAddress(city, zipCode, street, addressNo, state, country)
                        .map((line, index) => (
                      <span key={index}>
                        <span style={{marginLeft: index>0 ? "70px": "0px"}}>
                          {line}
                          <br />
                        </span>
                      </span>
                    ))}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="terms-accept">
          <div className="custom-checkbox">
            <input
              type="checkbox"
              id="terms_accept"
              className="me-2"
              checked={isCheck}
              onChange={handleCheck}
            />
            <label htmlFor="terms_accept" style={{color: "hsl(0, 1%, 51%)"}}>
              {" "}
              Oświadczam, że zapoznałem/am się z
              <a
                href="/regulamin"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary"
                style={{ cursor: "pointer", textDecoration: "none" }}
              >
                 {" "} Regulaminem  {" "}
              </a>
              i akceptuję wszystkie zawarte w nim warunki.
            </label>
          </div>
        </div>
      </dir>
    </div>
  );
};

export default AppointmentSummary;